/**
 * «Control de stock: Estricto / Flexible» (21-10-2026, decisión de Pablo).
 *
 * Ajuste por empresa (`company_settings.stock_control`), en Ajustes → Parámetros
 * de inventario, que solo cambia el admin:
 *   · `strict` (por defecto): un tratamiento sin stock se para (I7, «si falta
 *     stock, falta stock»).
 *   · `flexible`: el tratamiento se completa igual y el producto queda en
 *     negativo —«faltan albaranes»— hasta que entren las compras atrasadas.
 *     Nació para SAT Inver, que no lleva el almacén al día.
 *
 * Nunca se inventa una compra: el negativo es deuda a la vista, no stock.
 *
 * Esta es la copia del cliente de UNA regla con tres espejos: SQL
 * `_stock_flexible_on` (migración 20261021100000) y Deno
 * `supabase/functions/_shared/stockFlexible.ts`. Test de paridad:
 * `src/__tests__/stockControl.parity.test.ts`.
 */

export type StockControl = "strict" | "flexible";

export const STOCK_CONTROL_FLEXIBLE = "flexible";

export function esStockFlexible(valor: unknown): boolean {
  return valor === STOCK_CONTROL_FLEXIBLE;
}

/**
 * ¿Este número es un «faltan albaranes»? Solo en una empresa flexible y por
 * debajo de cero: en una estricta un negativo es un descuadre de los de
 * siempre y se sigue pintando como alerta.
 */
export function faltanAlbaranes(cantidad: number | null | undefined, flexible: boolean): boolean {
  return flexible && (Number(cantidad) || 0) < -1e-9;
}
